import _ from 'lodash';
import { FETCH_FOOTER, FETCH_FOOTER_PROMOS } from './FooterActions';

const FOOTER_GROUP_1_KEY = 'links';
const FOOTER_GROUP_2_KEY = 'networkList';
const FOOTER_GROUP_3_KEY = 'social';

const INITIAL_STATE = {
  fetched: false,
  links: null,
  networks: null,
  connect: null,
  legal: '',
  promosPanels: null,
};

export default function(state = INITIAL_STATE, action) {
  const data = _.get(action, 'payload.data', null);
  if (!data) return state;
  switch (action.type) {
    case FETCH_FOOTER: {
      const links = _.get(data, FOOTER_GROUP_1_KEY);
      const networks = _.get(data, FOOTER_GROUP_2_KEY);
      const connect = _.get(data, FOOTER_GROUP_3_KEY);
      const { legal, slimFooter } = data;
      return {
        ...state,
        fetched: true,
        links,
        networks,
        connect,
        legal,
        slimFooter,
      };
    }
    case FETCH_FOOTER_PROMOS: {
      let promosPanels = _.get(data, 'panels');
      const totalPromos = _.get(promosPanels, 'totalItems');
      if (!totalPromos) promosPanels = null;
      return {
        ...state,
        promosPanels,
      };
    }
    default:
      return state;
  }
}
